// extracted by mini-css-extract-plugin
export var disclaimer = "SwapMyBoxModal_disclaimer__4OgM5";
export var doNotCancel = "SwapMyBoxModal_doNotCancel__xfOaE";
export var mainText = "SwapMyBoxModal_mainText__0J3pm";
export var md = "768px";
export var noThanks = "SwapMyBoxModal_noThanks__b3N9H";
export var shared = "'../../../../shared.module.css'";
export var swapYourBox = "SwapMyBoxModal_swapYourBox__SBOM2";
export var textContent = "SwapMyBoxModal_textContent__Bwsg6";
export var yesLearnMore = "SwapMyBoxModal_yesLearnMore__UVq1n";